import React from 'react';

const AboutSection = ({ config, onUpdateParagraph }) => (
  <div className="bg-white rounded-lg shadow-lg p-6 mb-6" data-testid="about-section">
    <h2 className="text-xl font-bold mb-4">About Us Content</h2>
    <div className="space-y-4">
      {config.about_content.map((paragraph, index) => (
        <div key={`about-para-${index}`}>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Paragraph {index + 1}
          </label>
          <textarea
            data-testid={`about-paragraph-${index}`}
            value={paragraph}
            onChange={(e) => onUpdateParagraph(index, e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
            rows="3"
          />
        </div>
      ))}
    </div>
  </div>
);

export default AboutSection;
